import type { SelectOption } from '@property.com.au/ui-kit';
import { isNonEmptyArray } from '../app-kit/helpers/arrayHelpers';

const isDefaultValue = (options: SelectOption[], defaultValue: string): boolean =>
  options.some(({ value }) => value === defaultValue);

export const getSelectedOptionsOrDefault = ({
  currentSelection,
  previousSelection = [],
  defaultValue,
}: {
  currentSelection: SelectOption[];
  previousSelection?: SelectOption[];
  defaultValue: string;
}): SelectOption[] => {
  const isDefaultPreviouslySelected = isDefaultValue(previousSelection, defaultValue);
  const isDefaultCurrentlySelected = isDefaultValue(currentSelection, defaultValue);
  const selectDefaultOption = currentSelection.find(
    ({ value: optionValue }) => optionValue === defaultValue,
  );

  if (!isNonEmptyArray(currentSelection)) {
    // If no selection, return default
    return [{ label: '', value: defaultValue }]; // CKSelect doesn't validate label, so can just return value
  }
  if (isDefaultPreviouslySelected && isDefaultCurrentlySelected) {
    // If Default was AND is selected, remove it
    currentSelection.splice(0, 1);
    return [...currentSelection];
  }
  if (isDefaultCurrentlySelected && selectDefaultOption) {
    // If Default is selected AND wasn't, return default
    return [selectDefaultOption];
  }
  // Normal behaviour
  return [...currentSelection];
};
